

export const nl2br = (str: string) => {
  return str.replace(/(\r\n|\n\r|\r|\n)/g, '<br />')
}

export const removeParagraph = (str: string) => {
  return String(str).replace(/<\/?p[^>]*>/g, '')
}

export const capitalizeFirstLetter = (str: string) => {
  return str.charAt(0).toUpperCase() + str.slice(1).toLocaleLowerCase()
}

export const capitalizeLetters = (str: string) => {
  return str
    .split(' ')
    .map((word) => capitalizeFirstLetter(word))
    .join(' ')
}

export const formatString = (str: string, value: string) => {
  return str.includes('%s') ? str.replace('%s', value) : str
}